import { create } from 'zustand';
import { Lead, LeadFilters } from '../types/lead.types';

interface LeadsState {
  leads: Lead[];
  selectedLead: Lead | null;
  filters: LeadFilters;
  isLoading: boolean;
  error: string | null;
  
  setLeads: (leads: Lead[]) => void;
  setSelectedLead: (lead: Lead | null) => void;
  setFilters: (filters: LeadFilters) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  addLead: (lead: Lead) => void;
  updateLead: (id: string, updates: Partial<Lead>) => void;
  removeLead: (id: string) => void;
  clearLeads: () => void;
}

export const useLeadsStore = create<LeadsState>((set) => ({
  leads: [],
  selectedLead: null,
  filters: {},
  isLoading: false,
  error: null,
  
  setLeads: (leads) => set({ leads }),
  
  setSelectedLead: (lead) => set({ selectedLead: lead }),
  
  setFilters: (filters) => set({ filters }),
  
  setLoading: (loading) => set({ isLoading: loading }),
  
  setError: (error) => set({ error }),
  
  addLead: (lead) => set((state) => ({ 
    leads: [lead, ...state.leads] 
  })),
  
  updateLead: (id, updates) => set((state) => ({
    leads: state.leads.map((lead) =>
      lead.id === id ? { ...lead, ...updates } : lead
    ),
    selectedLead: state.selectedLead?.id === id 
      ? { ...state.selectedLead, ...updates } 
      : state.selectedLead,
  })),
  
  removeLead: (id) => set((state) => ({
    leads: state.leads.filter((lead) => lead.id !== id),
    selectedLead: state.selectedLead?.id === id ? null : state.selectedLead,
  })),
  
  clearLeads: () => set({ 
    leads: [], 
    selectedLead: null,
    filters: {},
    error: null 
  }),
}));